import * as React from 'react';
import { AddCircleOutline } from '@mui/icons-material';
import { Box, Chip, Popover, Tooltip } from '@mui/material';
import { IconButton } from '../IconButton/IconButton';

type TagsModalProps = {
  selectedTags: string[];
  tagOptions: string[];
  disabled: boolean;
  onDelete: (tag: string) => void;
  onAdd: (tag: string) => void;
};

export const TagsModal: React.FunctionComponent<TagsModalProps> = (
  props: TagsModalProps,
) => {
  const { selectedTags, disabled, tagOptions, onDelete, onAdd } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'popover' : undefined;

  if (!tagOptions.length) return <></>;
  return (
    <div>
      {selectedTags.map((tag, index) => {
        //  to hide the delete icon when disabled
        const handleDelete = disabled
          ? undefined
          : () => {
              onDelete(tag);
            };
        return (
          <Tooltip key={index} title={tag}>
            <Chip
              label={tag}
              onDelete={handleDelete}
              color="primary"
              className="overflow-hidden text-ellipsis whitespace-nowrap"
              style={{
                maxWidth: disabled ? '6em' : '8em',
                marginTop: '1px',
              }}
            />
          </Tooltip>
        );
      })}
      {!disabled && (
        <div className="w-full flex justify-center">
          <IconButton
            aria-describedby={id}
            onClick={handleClick}
            size="small"
            color="primary"
            disabled={disabled}
            icon={<AddCircleOutline />}
          />
        </div>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            borderRadius: '10px',
            width: '14em',
            maxHeight: '60em',
            overflowY: 'auto',
            border: '2px solid #951D1D',
          },
        }}
      >
        <Box display={'flex'} flexWrap={'wrap'} p={1} gap={1}>
          {tagOptions.map((tag, index) => {
            const isSelected = selectedTags.includes(tag);
            const isDisable = isSelected || disabled;
            return (
              <Tooltip
                key={index}
                title={tag}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [120, 10],
                        },
                      },
                    ],
                  },
                }}
              >
                <div
                  onClick={() => {
                    if (!isDisable) onAdd(tag);
                  }}
                >
                  <Chip
                    label={tag}
                    color="primary"
                    disabled={isDisable}
                    className="overflow-hidden text-ellipsis whitespace-nowrap"
                    style={{
                      maxWidth: '8em',
                      cursor: isDisable ? 'not-allowed' : 'pointer',
                    }}
                  />
                </div>
              </Tooltip>
            );
          })}
        </Box>
      </Popover>
    </div>
  );
};
